<template>
  <div class="staffhistoryDetail">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div
      class="visitStatusBox"
      :style="`background-color: ${color}`"
    >{{ headName }}</div>
    <div class="content">
      <p class="content-title">餐次信息</p>
      <van-cell title="餐次名称">
        <template #right-icon>
          <div style="width: 70%; text-align: right">
            {{ historyDetail.mealRuleName }}
          </div>
        </template>
      </van-cell>
      <van-cell title="餐次时间">
        <template #right-icon>
          {{ historyDetail.mealTimeStart }}~{{ historyDetail.mealTimeEnd }}
        </template>
      </van-cell>
      <van-cell title="计费规则">
        <template #right-icon>
          {{ historyDetail.payMoney }}/次
        </template>
      </van-cell>
      <van-cell title="支付方式">
        <template #right-icon>
          {{ historyDetail.payTypeName }}
        </template>
      </van-cell>
      <van-cell title="卡券名称" v-if="historyDetail.payType === 'COUPON_PAY'">
        <template #right-icon>
          {{ historyDetail.mealRuleName }}
        </template>
      </van-cell>
      <van-cell title="确认时间">
        <template #right-icon>
          {{ historyDetail.bookingLimitTime }}
        </template>
      </van-cell>
    </div>
    <div class="content">
      <p class="content-title">订餐信息</p>
      <van-cell title="消费区域">
        <template #right-icon>
          {{ historyDetail.zoneName }}
        </template>
      </van-cell>
      <van-cell title="用餐日期">
        <template #right-icon>
          {{ historyDetail.bookingDate }}
        </template>
      </van-cell>
      <van-cell title="内部用餐人" @click="onAttendees">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ historyDetail.innerPersons.length }}
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
      <van-cell title="外部用餐人">
        <template #right-icon>
          {{ historyDetail.outerPersons.length }}
        </template>
      </van-cell>
      <van-cell title="申请人">
        <template #right-icon>
          {{ historyDetail.personName }}
        </template>
      </van-cell>
      <div class="content">
        <p class="content-title">申请动态</p>
        <van-steps direction="vertical" :active="historyDetail.logs && historyDetail.logs.length - 1">
          <van-step v-for="son in historyDetail.logs">
            <div>{{ son.remark }}</div>
            <p>{{ son.createTime }}</p>
          </van-step>
        </van-steps>
      </div>
    </div>
    <div v-if="filterCancel(historyDetail.bookingStatus)" class="btns" @click="showCancelDialog = true">
      <div style="background-color: #3b86ff;">
        取消申请
      </div>
    </div>
    <div v-if="filterEat(historyDetail.bookingStatus)" class="btns">
      <div style="background-color: #3b86ff; display: flex; align-items: center; justify-content: center" @click="getCode">
        <van-icon name="qr" />
        <span style="margin-left: 10px">
          用餐码
        </span>
      </div>
    </div>
    <!--    <div v-if="historyDetail.operateCancel" class="btns" @click="onCancel">-->
    <!--      <div style="background-color: #3b86ff;">-->
    <!--        取消会议-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div v-if="personalInfo.staff && historyDetail.mineCreate && (historyDetail.meetingStatus === 'FINISH' || historyDetail.meetingStatus === 'CANCEL' || historyDetail.meetingStatus === 'AUDIT_OUTTIME' || historyDetail.meetingStatus === 'AUDIT_FAIL')" class="btns" @click="onRebook">-->
    <!--      <div style="background-color: #3b86ff;">-->
    <!--        重新预约-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <van-overlay :show="showTips" @click="showTips = false">-->
    <!--      <div class="cover" @click.stop>-->
    <!--        <svg-icon icon-class="share" class-name="share" />-->
    <!--        <svg-icon icon-class="share_btn" class-name="shareBtn" @click="showTips = false" />-->
    <!--      </div>-->
    <!--    </van-overlay>-->
    <van-dialog
      v-model="showCancelDialog"
      title="温馨提示"
      show-cancel-button
      @confirm="confirmCancel"
    >
      <van-cell-group>
        <van-field v-model="messageCancel" class="control" rows="1" autosize type="textarea" placeholder="请输入取消原因" />
      </van-cell-group>
    </van-dialog>
    <!--    <van-dialog-->
    <!--      v-model="showMeetingCancelDialog"-->
    <!--      title="温馨提示"-->
    <!--      show-cancel-button-->
    <!--      @confirm="confirmMeetingCancel"-->
    <!--    >-->
    <!--      <van-cell-group>-->
    <!--        <van-field v-model="messageCancel" class="control" rows="1" autosize type="textarea" placeholder="请输入取消原因" />-->
    <!--      </van-cell-group>-->
    <!--    </van-dialog>-->
  </div>
</template>

<script>
import {
  eatInfo,
  bookingApplyInfo,
  bookingCancel
} from '@/api/user';
import { Step, Steps } from 'vant';
export default {
  name: 'MealBookInfo',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  data() {
    return {
      fromName: this.$route.query.from,
      subHead: '详情',
      headName: '',
      color: '',
      personalInfo: {},
      showRefuseDialog: false,
      showTips: false,
      showShareBtn: false,
      showCancelDialog: false,
      showMeetingCancelDialog: false,
      message: '',
      messageCancel: '',
      historyDetail: {
        outerPersons: [],
        innerPersons: [],
        logs: []
      },
      acpyVisitorsArr: [
        {
          name: '张大大',
          phone: '13507245734',
          carNumber: '',
          status: 'CANCEL'
        },
        {
          name: '张大大',
          phone: '13507245734',
          carNumber: '粤AC527',
          status: 'WAITING_VISIT'
        },
        {
          name: '张大大',
          phone: '13507245734',
          status: 'FINISH',
          carNumber: ''

        }
      ],
      statusMap: {
        CANCEL: ['已取消', '#919191'],
        BOOKING: ['预定中', '#3b86ff'],
        START_BOOKING: ['发起预定', '#3b86ff'],
        BOOKED: ['预定成功', '#2DCC2C'],
        LOCK_BOOKING: ['已确认', '#2DCC2C']
      }
    };
  },
  created() {
    this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
    this.getHistoryDetail();
  },
  methods: {
    filterCancel(val) {
      const list = ['BOOKING', 'BOOKED', 'START_BOOKING'];
      return this.$route.query.from === 'apply' && list.includes(val);
    },
    filterEat(val) {
      const list = ['LOCK_BOOKING'];
      return this.$route.query.from === 'review' && list.includes(val);
    },
    goBack() {
      this.$router.push({ name: 'mealBook' });
    },
    getHistoryDetail() {
      if (this.fromName === 'apply') {
        bookingApplyInfo({ id: this.$route.query.id }).then(response => {
          this.historyDetail = response.data;
          this.headName = this.statusMap[response.data.bookingStatus][0];
          this.color = this.statusMap[response.data.bookingStatus][1];
        });
      } else {
        eatInfo({ id: this.$route.query.id }).then(response => {
          this.historyDetail = response.data;
          this.headName = this.statusMap[response.data.bookingStatus][0];
          this.color = this.statusMap[response.data.bookingStatus][1];
        });
      }
    },
    confirmCancel() {
      const data = {
        id: this.historyDetail.id,
        remake: this.messageCancel
      };
      bookingCancel(data).then(response => {
        if (response.code === 200) {
          this.$toast.success('取消成功');
          setTimeout(() => {
            location.reload();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    onAttendees() {
      if (this.historyDetail.innerPersons.length > 0) {
        const list = JSON.stringify(this.historyDetail.innerPersons);
        this.$router.push({ name: 'showStaffList', query: { list, title: '内部用餐人' }});
      }
    },
    getCode() { // 用餐码
      this.$router.push({ name: 'eatCode', query: { id: this.$route.query.id }});
    }
  }
};
</script>

<style lang="less">
.staffhistoryDetail {
  min-height: 100vh;

  .control {
    .van-field__control{
      text-align: left;
    }
  }

  .van-cell__title {
    -webkit-box-flex: unset;
    -webkit-flex: unset;
    flex: unset;
  }
  padding-bottom: 0.2rem;
  .content {
    padding-bottom: 0.15rem;
    position: relative;
    .inviteWechatShare {
      background-color: #57c55f;
      border-radius: 100%;
      padding: 5px;
    }
    .inviteCopyShare {
      margin-left: 0.02rem;
      background-color: #3b86ff;
      border-radius: 100%;
      padding: 5px;
    }
    .signIn {
      position: absolute;
      top: -10px;
      right: 10px;
      z-index: 19999;
    }
    .content-title,
    .visitStatus {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0rem 0.15rem;
    }
    .content-detail,
    .content-reason {
      font-size: 0.17rem;
      color: #333;
      background: #fff;
      padding: 0.18rem 0.15rem;
    }
    .content-detail p:not(:last-child) {
      margin-bottom: 0.1rem;
    }
    .content-reason {
      padding: 0rem 0.15rem;
      .content-reasonItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.55rem;
        line-height: 0.55rem;
        .faceImg {
          width: 0.33rem;
          height: 0.33rem;
          line-height: 0.33rem;
          .svg-icon {
            width: 100%;
            height: 100%;
          }
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }
      .content-reasonItem:not(:last-child) {
        border-bottom: 1px solid #e5e5e5;
      }
    }
    .has-small-magb{
      position: relative;
      margin-bottom: 0.1rem;
      .content-reasonItem[class~='has-status']{
        height:0.73rem;
      }
      .tip-status{
        width: 0.65rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        border-radius: 14px 0px 0px 14px;
        color: #fff;
        font-size: .14rem;
        position: absolute;
        right: 0px;
        &.CANCEL,
        &.UNVISIT,
        &.AUDIT_FAIL,
        &.OUTTIME_AUDIT {
          background-color: rgba(51, 51, 51, 0.5);
        }

        &.WAITING_AUDIT,
        &.WAITING_VERIFY {
          background-color: #f2b230;
        }

        &.OUTTIME_VISIT,
        &.AUDIT_REJECT {
          background-color: #f76260;
        }

        &.VISITING,
        &.WAITING_VISIT {
          background-color: #3b86ff;
        }

        &.FINISH,
        &.AUDIT_PASSED {
          background-color: #2dcc2c;
        }
      }

    }

    .itemClass {
      background-color: #FFFFFF;
      padding: 0.145rem 0.16rem 0 0.145rem;
      .meetingItem {
        padding-bottom: 0.16rem;
        font-size: 0.16rem;
        color: #333333;
        border-bottom: 1px solid #ebedf0;
      }
    }
  }
  .btns {
    display: flex;
    justify-content: space-between;
    //margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding: 0rem 0.28rem;
    > div {
      width: 100%;
      height: 0.47rem;
      font-size: 0.18rem;
      color: #fff;
      line-height: 0.47rem;
      text-align: center;
    }
    div:first-child {
      background: #FFBE00;
      border: 1px solid rgba(5, 5, 5, 0.08235294117647057);
      opacity: 1;
      border-radius: 5px;
    }
    div:last-child {
      background: #2DCC2C;
      border: 1px solid rgba(5, 5, 5, 0.08235294117647057);
      opacity: 1;
      border-radius: 5px;
    }
  }
  //.van-field__control {
  //  text-align: left;
  //}
  .shareBtns {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    padding: 0rem 0.28rem;
    > div {
      width: 100%;
      height: 0.47rem;
      font-size: 0.18rem;
      color: #fff;
      border-radius: 5px;
      line-height: 0.47rem;
      text-align: center;
    }
    div:first-child {
      background: rgba(255, 190, 0, 1);
      border: 2px solid rgba(5, 5, 5, 0.0823);
    }
    div:last-child {
      background: rgba(45, 204, 44, 1);
      border: 2px solid rgba(5, 5, 5, 0.0823);
    }
  }
  .cover {
    position: absolute;
    opacity: 0.5;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    .share {
      position: absolute;
      right: 20px;
      top: 10px;
      width: 2rem;
      height: 2rem;
    }
    .shareBtn {
      position: absolute;
      right: 0;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      width: 2rem;
      height: 2rem;
    }
  }

  .van-overlay {
    z-index: 19999;
  }

}
.content-detail:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, 1);
}
.stall_tip{
  padding: 0 0.15rem;
  font-size: 0.14rem;
  color: #888;
  margin-top: 0.1rem;
}

</style>
